import React from 'react';
import { FiLoader } from 'react-icons/fi';

const LoadingSpinner = ({ fullPage = false, text = 'Loading...' }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center ${
        fullPage ? 'min-h-screen' : 'min-h-[200px]'
      }`}
    >
      <div className="flex flex-col items-center">
        <FiLoader className="w-8 h-8 text-gray-600 animate-spin mb-3" />
        <span className="text-gray-600">{text}</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;